import React from 'react'

const AboutRoute = () => {
  return <div />
}

export { AboutRoute }
